module.exports = __webpack_public_path__ + "wsSharedWorker.worker.js"